<ng-container *transloco="let t; scope: 'catalog'">
  <div class="listing-filters-title">
    <div class="flex listing-filters-title-filters flex--jc-space-between" *ngIf="activeFacets$ | async as activeFacets">
      <ng-container *ngIf="activeFacets">
        <div class="flex flex--ai-center">
          <div class="default-font-sizes default-font-sizes--medium">{{ t("catalog.product-filter.filter-selection") }}</div>
          <span class="listing-filters-title-count default-font-sizes default-font-sizes--medium" *ngIf="activeFacets.length > 0">
            {{ activeFacets.length }}
          </span>
        </div>
        <button class="btn-slim listing-active-filters-reset" *ngIf="activeFacets.length > 0" (click)="resetFilter()">
          {{ t("catalog.product-filter.reset-filter") }}
        </button>
      </ng-container>
    </div>
  </div>
  <div class="listing-filters-inner">
    <div class="listing-filters-items" *ngIf="facets">
      <ng-container *ngFor="let facet of facets | where : multipleChoicesAvailable; trackBy: trackByFn">
        <app-product-facet-item
          [facet]="facet"
          [resetSelection$]="resetSelection.asObservable()"
          (facetChanged)="facetChanged.emit($event)"
        ></app-product-facet-item>
      </ng-container>
    </div>
    <div *ngIf="activeFacets$ | async as activeFacets" class="tablet-hidden">
      <button class="btn-slim listing-active-filters-reset" *ngIf="activeFacets.length > 0" (click)="resetFilter()">
        {{ t("catalog.product-filter.reset-filter") }}
      </button>
    </div>
  </div>
</ng-container>
